/* eslint-disable */
// @ts-nocheck
import React from 'react';
import useExternalAppStoreData from '../../support/useExternalAppStoreData';
type AppleStoreType = 'apple';
type AndroidStoreType = 'android';
export const APPLE: AppleStoreType = 'apple';
export const ANDROID: AndroidStoreType = 'android';
export type Store = AppleStoreType | AndroidStoreType;
type Props = {
  appId: string;
  country?: string;
  store: Store;
  hideAppName?: boolean;
  containerClassName?: string;
  imageClassName?: string;
  message?: string;
  messageClassName?: string;
};
const DEFAULT_MESSAGE = 'Unable to find app';

function AppStoreIcon(props: Props) {
  const {
    appId,
    store,
    country,
    imageClassName,
    hideAppName = false,
    containerClassName,
    message,
    messageClassName,
  } = props;
  const { appData, error } = useExternalAppStoreData({
    appId,
    store,
    country,
  });

  if (error) {
    return (
      <div data-testid="app-store-icon" className={containerClassName}>
        <span data-testid="app-store-icon_not-found-messagae" className={messageClassName}>
          {message || DEFAULT_MESSAGE}
        </span>
      </div>
    );
  }

  return (
    <div data-testid="app-store-icon" className={containerClassName}>
      <img className={imageClassName} src={appData.imageUrl} />
      {!hideAppName && appData.name}
    </div>
  );
}

export default AppStoreIcon;
